<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,782.5c2.88,0,5.54,1.37,7.4,3.47l1.48-2.06v6.37l-5.55-2.22l2.21-0.74c-1.46-1.55-3.47-2.59-5.54-2.59
	c-3.98,0-7.77,3.8-7.77,7.78h-2.22C-9.49,787.18-4.83,782.5,0.5,782.5L0.5,782.5z M0.5,790.28L0.5,790.28L0.5,790.28
	c1.23,0,2.22,1,2.22,2.22l0,0l0,0l0,0c0,1.23-0.99,2.22-2.22,2.22l0,0l0,0l0,0c-1.23,0-2.22-1-2.22-2.22l0,0l0,0l0,0
	C-1.72,791.27-0.73,790.28,0.5,790.28L0.5,790.28L0.5,790.28z M10.49,792.5L10.49,792.5c0,5.33-4.67,10-9.99,10
	c-2.88,0-5.55-1.37-7.41-3.46l-1.48,2.05v-6.37l5.55,2.22l-2.21,0.74c1.46,1.55,3.47,2.59,5.55,2.59c3.98,0,7.77-3.79,7.77-7.77v0
	H10.49z"/>
</svg>

</template>